/* 
 * Loads in the quiz post navigation.
 */


(function ($) {
    var $document = $(document),
        $window = $(window);

    $document.ready(function () {
        var questions = $('#quiz .questions .question'),
            answered = 0,
            total = Object.keys(answer_key).length;

        questions.on('click','.answer .button',function (e){
            e.preventDefault();
            var btn = $(this),
                question = btn.closest('.question'),
                answer = btn.closest('.answer'),
                q_id = question.attr('id'),
                target = $(this).attr('href').substring($(this).attr('href').indexOf("#")+1),
                style = answer_key[q_id][target],
                progress = $('#quiz .progress-bar');

            if(question.hasClass('unanswered')) {
                answered += 1;
                progress.addClass('display').find('.completed').empty().append(answered);
            }

            question.removeClass('unanswered').addClass('answered');
            // question.find('.answer').removeClass('question-unanswered').addClass('question-answered').find('.button').replaceTag('<span>', true);
            question.find('.answer').removeClass(['question-unanswered','correct','incorrect']).addClass('question-answered');
            question.find('.response').removeClass(['display']);

            answer.addClass(style);
            $('#'+target).addClass('display');

            question.next().addClass('display');

            if(answered == total) {
                $('#quiz').removeClass('is-not-complete').addClass('is-complete');
                $('#quiz .conclusion').addClass('display');
            }

        })

    });

    $.extend({
        replaceTag: function (currentElem, newTagObj, keepProps) {
            var $currentElem = $(currentElem);
            var i, $newTag = $(newTagObj).clone();
            if (keepProps) {
                newTag = $newTag[0];
                newTag.className = currentElem.className;
                newTag.classList = currentElem.classList;
                newTag.attributes = currentElem.attributes;
            }
            $currentElem.wrapAll($newTag);
            $currentElem.contents().unwrap();
            return this;
        }
    });

    $.fn.extend({
        replaceTag: function (newTagObj, keepProps) {
            return this.each(function() {
                $.replaceTag(this, newTagObj, keepProps);
            });
        }
    });

})(jQuery);